// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Arrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 29 12" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M28.477 5.977 22.5 11.953v-4.5H0V4.5h22.5V0z" fill="#8C9091" fillRule="evenodd" />
	</svg>
);
export default Arrow;
